module.exports = __webpack_public_path__ + "img/betfair-logo.e12dae0.png";